module.exports = __webpack_public_path__ + "img/logo_auth.2ffaf5f9.png";